module.exports = __webpack_public_path__ + "static/img/m_banner2.7a52af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m_banner2.png
// module id = phqF
// module chunks = 0